//title
export const LOAD_AUDITS_REQUEST = 'LOAD_AUDITS_REQUEST';
export const LOAD_AUDITS_SUCCESS = 'LOAD_AUDITS_SUCCESS';
export const LOAD_AUDITS_FAIL = 'LOAD_AUDITS_FAIL';
